import React from "react"
import { FiArrowRight, FiArrowLeft } from "react-icons/fi"
import "./styles.css"

const LevelNavigatorComponent = (props) => {
    const { skillLevel, maxLevel, handleClickInfoNavigator, isBaseSkill } = props
    return (
        <div className="level-controller">
            {(skillLevel > 0 && !isBaseSkill) || (isBaseSkill && skillLevel > 1)  ? (
                <div id="lvlNavigator" onClick={(e) => handleClickInfoNavigator(e, maxLevel, -1)}>
                    <FiArrowLeft size={20} color="#808080" />{" "}
                    <span>Nível Anterior</span>
                </div>
            ) : (
                    <div id="lvlNavigator" />
                )}
            {
                skillLevel !== maxLevel ? <div id="lvlNavigator" onClick={(e) => handleClickInfoNavigator(e, maxLevel, 1)}>
                    <span>Próximo Nível</span>
                    <FiArrowRight size={20} color="#808080" />{" "}
                </div> : <div id="lvlNavigator" />
            }

        </div>
    )
}

export default LevelNavigatorComponent
